import React from 'react';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import {
    JobTitleLiquidationSetDataForm,
    JobTitleLiquidationSetFilters
} from '../../../../app/models/JobTitleLiquidationSet';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DeductionSetSwitchChange from '../subcomponents/JobTitleLiquidationSetSwitchChange';
import JobTitleLiquidationSetFilter from './JobTitleLiquidationSetFilter';

interface Props {
    jobTitleLiquidationSets: JobTitleLiquidationSetDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: JobTitleLiquidationSetFilters;
    setFilter: (filter: JobTitleLiquidationSetFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const JobTitleLiquidationSetDataTable = ({
    jobTitleLiquidationSets,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: JobTitleLiquidationSetDataForm, index: any, column: any) => (
                <span className="">{row.id}</span>
            )
        },
        {
            name: 'Nombre del Set de Documentos',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: JobTitleLiquidationSetDataForm, index: any, column: any) => (
                <span className="">{row.job_title?.name}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row?.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: JobTitleLiquidationSetDataForm, index: any, column: any) => (
                <DeductionSetSwitchChange
                    checkValue={row.is_active ?? true}
                    deductionSetId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: JobTitleLiquidationSetDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            {/* <div className="row mt-3">
                <div className="col">
                    <JobTitleLiquidationSetFilter filter={filter} setFilter={setFilter} />
                </div>
            </div> */}
            <DefaultDataTable
                columns={columns}
                data={jobTitleLiquidationSets}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default JobTitleLiquidationSetDataTable;
